export const USER_SUCCESS_LOGIN = `@USER/SUCCESS_LOGIN`;
export const USER_SUCCESS_REGISTER = '@USER/SUCCESS_REGISTER';
export const USER_FAILED_REGISTER = '@USER/FAILED_REGISTER';
export const USER_SUCCESS_REGISTER_COMPANY = '@USER/SUCCESS_REGISTER_COMPANY';
export const USER_SUCCESS_CHANGE_PASSWORD = '@USER/SUCCESS_CHANGE_PASSWORD';
export const USER_CHANGE_INPUT_USER = '@USER/CHANGE_INPUT_USER';
export const USER_LOGOUT = '@USER/LOGOUT'
export const USER_GET_COMPANY_LIST = '@USER/USER_GET_COMPANY_LIST'